// extracted by mini-css-extract-plugin
module.exports = {"video_player":"S8cFx","videoPlayer":"S8cFx","video_container":"syET-","videoContainer":"syET-"};